<div class="loader"></div>
<div class="logo">
  <img alt="Logo" class="logo-img" src="/assets/img/lekkerland24-logo.svg"/>
</div>
